export default "__VITE_ASSET__312b9619__"